export type ApiMoney = {
  amount: string;
  currency: string;
};
